import { ReactNode } from "react";

interface InfoItemProps {
  title?: string;
  children?: ReactNode;
  rootClassName?: string;
  titleClassName?: string;
  className?: string;
}

export default function InfoItem({
  title,
  children,
  rootClassName = "",
  titleClassName = "",
  className = "",
}: InfoItemProps) {
  return (
    <div
      className={`flex justify-between items-center border-b py-2 border-extra-light ${rootClassName}`}
    >
      {title ? (
        <h4 className={`text-extra-gray font-medium  ${titleClassName}`}>
          {title}
        </h4>
      ) : null}
      <div className={`font-medium text-display-body ${className}`}>
        {children || "N/A"}
      </div>
    </div>
  );
}
